import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import { numeralFormat } from 'src/utils/misc';

interface TileRiskAvoidanceProps {
  impactLower: number;
  impactUpper: number;
  nearMisses: number;
}

export const TileRiskAvoidance: React.FC<TileRiskAvoidanceProps> = ({ impactLower, impactUpper, nearMisses }) => {
  return (
    <BaseCard>
      <span className="c-title">Risk Avoidance</span>

      <span className="description">
        Security programme has avoided{' '}
        <b>
          {nearMisses} near miss{nearMisses === 1 ? '' : 'es'}
        </b>{' '}
        in the last 365 days, which could have resulted in losses of:
      </span>
      <div style={{ flex: 1 }} />
      <div>
        {nearMisses ? (
          <Poppins weight={600} color="gp1" px={26}>
            {numeralFormat(impactLower)} - {numeralFormat(impactUpper)}
          </Poppins>
        ) : (
          <Poppins weight={600} color="gp1" px={26}>
            N/A
          </Poppins>
        )}
      </div>
    </BaseCard>
  );
};
